export const minWidth = 60;
export const defaultWidth = 140;
export const inputButtonWidth = 30;
export const boolWidth = 90;
export const charWidth = 8;
